module.exports = __webpack_public_path__ + "static/img/1046_small.469c189.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1046_small.png
// module id = B+46
// module chunks = 1